import store from './store'
import { AppUtil, BrowserUtil } from 'kuaidong-lib'
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators'

/** 当前路由 meta.hideTitleBar。init 在 await 之后读它，避免异步结果把刚藏掉的顶栏又打开。 */
let routeHidesTitleBar = false

export const setRouteHidesTitleBar = (_hide: boolean) => {
  routeHidesTitleBar = _hide
}

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: 'system',
})
class SystemModule extends VuexModule {
  isUnderApp = false
  titleBarVisible = false
  feedbackPath = ''

  @Mutation
  reset() {
    // Do nothing.
  }

  @Action
  async init() {
    this.initIsUnderApp()
    this.initTitleBarVisible()
  }

  @MutationAction
  async initIsUnderApp() {
    const isUnderApp = await AppUtil.isUnderApp()

    return { isUnderApp }
  }

  @MutationAction
  async initTitleBarVisible() {
    const underAppOrWeapp = (await AppUtil.isUnderApp()) || BrowserUtil.isWeapp()

    return { titleBarVisible: routeHidesTitleBar ? false : underAppOrWeapp }
  }

  @MutationAction
  async showTitleBar() {
    return { titleBarVisible: true }
  }

  @MutationAction
  async hideTitleBar() {
    return { titleBarVisible: false }
  }

  @Mutation
  setTitleBarVisible(value: boolean) {
    this.titleBarVisible = value
  }

  @Mutation
  setFeedBackPath(v: string) {
    this.feedbackPath = v
  }
}

export default getModule(SystemModule)
